// Environment pill for the top bar, as in Vendia Quote: "STAG Build 26.10.22-1305".
// VITE_APP_ENV and the build version are baked in at build time by the
// deployment scripts. Brand colours only: staging amber, production navy,
// development slate.

import { Chip, Tooltip } from '@mui/material';

import { UI } from '../../../brand/ui';
import { t } from '../../../i18n';

const CODES: Record<string, string> = { development: 'DEV', staging: 'STAG', production: 'PROD' };
const COLORS: Record<string, string> = { development: UI.slate, staging: UI.warning, production: UI.navy };

export const appEnvironment = import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE ?? 'development';

export function EnvironmentChip() {
  const code = CODES[appEnvironment] ?? appEnvironment.slice(0, 4).toUpperCase();
  const label = t('shell.environmentBuild', { env: code, version: __APP_VERSION__ });
  const tooltip = CODES[appEnvironment] ? t(`shell.environment.${appEnvironment}`) : appEnvironment;
  return (
    <Tooltip title={tooltip}>
      <Chip
        size="small"
        label={label}
        data-testid="environment-chip"
        sx={{
          height: 22,
          fontSize: '0.68rem',
          fontWeight: 700,
          letterSpacing: '0.04em',
          bgcolor: COLORS[appEnvironment] ?? UI.slate,
          color: UI.white
        }}
      />
    </Tooltip>
  );
}
